// import React, { useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useLocation } from 'react-router-dom';
// import { slugs } from '../Constant/slugs';
// import { signInImage } from '../Constant/api';
// import ContactUSLogin from './ContactUSLogin';

// export default function Home() {
//   const dispatch = useDispatch()

//   return (
//     <div style={{ height: "100vh", backgroundColor: "#fff", marginTop: 10 }}>
//       <div className="row">
//         <div style={{ margin: "10px" }} className="center">
//           <img
//             src={signInImage}
//             style={{ height: "30vh", width: "30vh", objectFit: "contain" }}
//           />
//         </div>
//         <div className="row" >
//           <Link to={`${slugs.demo_exam}`} className="col-sm-3 col-6 center" style={{ padding: "20px" }}>
//             <img
//               className="home-icons"
//               src="https://api.networkeducationalacademy.com/wp-content/uploads/2026/04/classtest.png"
//             />
//             <div className="home-fonts">
//               All Exam
//             </div>
//           </Link>
//           <Link to={`${slugs.courses_list}`} className="col-sm-3  col-6 center" style={{ padding: "20px" }}>
//             <img
//               className="home-icons"
//               src="https://api.networkeducationalacademy.com/wp-content/uploads/2026/04/course.png"
//             />
//             <div className="home-fonts">
//               Courses
//             </div>
//           </Link>
//           {/* <Link to={`${slugs.classroom}`} className="col-sm-3 col-6 center" style={{ padding: "20px" }}>
//             <img
//               className="home-icons"
//               src="https://api.networkeducationalacademy.com/wp-content/uploads/2026/04/classtest.png"
//             />
//             <div className="home-fonts">
//               Class Exam
//             </div>
//           </Link> */}
//           {/* <Link to={`${slugs.demo_exam}`} className="col-sm-3 col-6 center">
//             <img
//               className="home-icons"
//               src="https://api.networkeducationalacademy.com/wp-content/uploads/2026/04/classtest.png"
//             />
//             <div className="home-fonts">
//               Demo Exam
//             </div>
//           </Link> */}
//           {/* <Link to={`${slugs.book_list_user}/skill-test`} className="col-6 center">
//             <img
//               className="home-icons"
//               src="https://api.widihakwon.com/wp-content/uploads/2024/03/textbook.png"
//             />
//             <div className="home-fonts">
//               Profile
//             </div>
//           </Link> */}

//         </div>
// 			<ContactUSLogin />

//       </div>
//     </div>
//   )
// }


import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { slugs } from "../Constant/slugs";
import { signInImage } from "../Constant/api";
import ContactUSLogin from "./ContactUSLogin";
import "./Home.css";
import axios from "axios";

export default function Home() {
  const getYoutube = () => {
    axios({
      method: "POST",
      url: `http://localhost:4000/youtube_download`,
      data:
      {
        "url": "https://www.youtube.com/watch?v=kBt1eB_NE9s",
        "quality": "360"
      }
    }
    )
      .then(res => {
        console.log(res.data)
      })
  }
  useEffect(() => {
    getYoutube()
  }, [])
  return (
    <main className="student-home">
      <section className="student-home-container">
        <div className="student-home-logo">
          <img
            src={signInImage}
            alt="Network Educational Academy"
          />
        </div>

        <div className="student-dashboard-links">
          <Link
            to={slugs.courses_list}
            className="student-dashboard-card"
          >
            <div className="student-dashboard-icon">
              <img
                src="https://api.networkeducationalacademy.com/wp-content/uploads/2026/09/blended-learning.png"
                alt=""
              />
            </div>

            <h2 className="student-dashboard-title">
              Courses
            </h2>

            <p className="student-dashboard-description">
              Access your classes, videos and course materials.
            </p>

            <span className="student-dashboard-action">
              Open Courses
            </span>
          </Link>
          <Link
            to={slugs.written_exam}
            className="student-dashboard-card"
          >
            <div className="student-dashboard-icon">
              <img
                src="https://api.networkeducationalacademy.com/wp-content/uploads/2026/04/classtest.png"
                alt=""
              />
            </div>

            <h2 className="student-dashboard-title">
              Written Exam
            </h2>

            <p className="student-dashboard-description">
              View and attempt all available examinations.
            </p>

            <span className="student-dashboard-action">
              Open Exams
            </span>
          </Link>

          <Link
            to={slugs.demo_exam}
            className="student-dashboard-card"
          >
            <div className="student-dashboard-icon">
              <img
                src="https://api.networkeducationalacademy.com/wp-content/uploads/2026/09/question.png"
                alt=""
              />
            </div>

            <h2 className="student-dashboard-title">
              MCQ Exam
            </h2>

            {/* <p className="student-dashboard-description">
              View and attempt all available examinations.
            </p> */}

            <span className="student-dashboard-action">
              Open Exams
            </span>
          </Link>

          <Link
            to={"/profile"}
            className="student-dashboard-card"
          >
            <div className="student-dashboard-icon">
              <img
                src="https://api.networkeducationalacademy.com/wp-content/uploads/2026/09/male.png"
                alt=""
              />
            </div>

            <h2 className="student-dashboard-title">
              Profile
            </h2>

            {/* <p className="student-dashboard-description">
              View and attempt all available examinations.
            </p> */}

            <span className="student-dashboard-action">
              Profile
            </span>
          </Link>
        </div>

        <p className="student-home-notice">
          माथि दिइएको Course Folder मा Click गरेर तपाईंले
          लिइरहनुभएको कोर्स Check गर्नुहोस्। केही समस्या भएमा
          Viber / WhatsApp मा Message गर्नुहोस्।
        </p>

        <div className="student-contact-section">
          <ContactUSLogin />
        </div>
      </section>
    </main>
  );
}